import { useTranslation } from 'react-i18next';

import type { UserDto } from '@/services/ws-permissions/src/main/resources/rest-api';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { useNotification } from '@/js/libs/ui/src/V2';

import type { CompanyIdentifiersFragment } from 'src/modules/CompaniesSwitch/context.tsx';
import { useCompanySwitchContext } from 'src/modules/CompaniesSwitch/context.tsx';

// Clears the switcher and warns the user when the identity loaded for the selected company belongs to another one:
// ws-permissions resolves a deactivated or ungranted company to the user's own company without an error.
export const useRevertIgnoredCompanySwitch = () => {
  const [t] = useTranslation();
  const notify = useNotification();
  const onCompanyChange = useCompanySwitchContext('onCompanyChange');

  return useCallbackRef((requestedCompany: CompanyIdentifiersFragment | null, user: Pick<UserDto, 'company'> | undefined) => {
    if (!requestedCompany || !user || user.company.id === requestedCompany.id) {
      return;
    }
    onCompanyChange(null);
    notify.warn({ body: t('messages:COMPANY_SWITCH_REVERTED', { companyName: requestedCompany.name }) });
  });
};
